import { makeAutoObservable } from "mobx";

import { SearchObject } from "app/common/Model/SearchObject";
import { toast } from "react-toastify";
import { checkSearchObject } from "app/common/LocalFunction";
import {
  getDuplicatePhoneNumber,
  getPatientByPhone,
  saveMainPhoneNumForListPatient,
} from "app/services/PatientService";

const defaultValue = {};
export default class PatientDuplicatePhoneStore {
  searchPatientDuplicatePhone = new SearchObject();
  pagePatientDuplicatePhone = null;
  openFormCreateOrEdit = false;
  openConfirmDelete = false;
  selectedPatientPhone = null;
  selectedRowDuplicatePhone = [];

  constructor() {
    makeAutoObservable(this);
  }

  pagingPatientDuplicatePhone = async () => {
    return await getDuplicatePhoneNumber(this.searchPatientDuplicatePhone)
      .then(({ data }) => {
        this.pagePatientDuplicatePhone = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu hạng khách hàng có lỗi");
      });
  };

  handleChangeFormSearch = (searchPatientDuplicatePhone) => {
    this.searchPatientDuplicatePhone = {
      ...this.searchPatientDuplicatePhone,
      ...searchPatientDuplicatePhone,
    };
    this.pagingPatientDuplicatePhone();
  };

  saveMainPhoneNumForListPatient = async (obj, { setSubmitting }) => {
    let items = obj?.items?.map((el) => ({
      ...el,
      isMainPhoneNumber:
        el?.id === this?.selectedRowDuplicatePhone?.[0]?.id ? true : false,
    }));
    return saveMainPhoneNumForListPatient([...items])
      .then(({ data }) => {
        toast.success("Lưu thông tin thành công!");
        this.handleClosePopup();
        this.pagingPatientDuplicatePhone();
        return data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lưu thông tin có lỗi");
      })
      .finally(() => setSubmitting(false));
  };

  setSelectedRowDuplicatePhone = (list) => {
    this.selectedRowDuplicatePhone = list;
  };

  handleOpenFormCreateOrEdit = (phoneNumber) => {
    getPatientByPhone(phoneNumber).then(({ data }) => {
      const mainPhoneNumber = data?.find((el) => el?.isMainPhoneNumber);
      this.selectedRowDuplicatePhone = [{ ...mainPhoneNumber }];
      this.selectedPatientPhone = data;
      this.openFormCreateOrEdit = true;
    });
  };

  handleClosePopup = () => {
    this.openFormCreateOrEdit = false;
    this.selectedPatientPhone = null;
  };

  resetStore = () => {
    this.searchPatientDuplicatePhone = new SearchObject();
    this.pagePatientDuplicatePhone = null;
    this.openConfirmDelete = false;
  };
}
